

//SEM USO ATÉ AGORA


import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> {
    //Utiliza o método isAuthenticated para verificar a autenticação
    return this.authService.isAuthenticated().pipe(
      map(isAuthenticated => {
        if (isAuthenticated) {
          return true; //Permite o acesso à rota se o utilizador estiver autenticado
        } else {
          this.router.navigate(['/login']); //Redireciona para o login se não autenticado
          return false;
        }
      })
    );
  }
}